import Vue from 'vue';
import Vuex from 'vuex'; // https://vuex.vuejs.org/ru/guide/

Vue.use(Vuex);

import globalGetters from './globalGetters';
import globalActions from './globalActions';
import globalMutations from './globalMutations';

export default new Vuex.Store({
  strict: true,
  state: {
    settings: null,
    scannerPageType: null, // live, prematch
    scannerPageName: null, // arbs, valuebets
    userData: null,
    userBookmakers: null,
    directories: null,
    currencies: null,
    interfaceZoom: null,
    sidebarHeight: '100%',
    countriesList: null,
    leaguesList: null,
    headerSearchQuery: '',
    globalLoadError: false,
    // eslint-disable-next-line max-len
    globalLoadWarning: {isWarning: false, warningText: null, warningLink: null, warningLinkTitle: null},
    arbsFormulas: null,
    defaultFilterRequestParams: null,
    statusWidgetCollapsed: true,
    newUnreadStatus: null,
    numberOfUnreadStatus: null,
    prevKoefFormat: null,
    showHints: true,
    percentValue: null,
  },
  mutations: {
    ...globalMutations,
  },
  actions: {
    ...globalActions,
  },
  getters: {
    ...globalGetters,
  },
});
